import React from 'react';

interface PTTButtonProps {
  isTransmitting: boolean;
  disabled: boolean;
  onMouseDown: () => void;
  onMouseUp: () => void;
  onMouseLeave: () => void;
  onTouchStart: () => void;
  onTouchEnd: () => void;
}

export default function PTTButton({
  isTransmitting,
  disabled,
  onMouseDown,
  onMouseUp,
  onMouseLeave,
  onTouchStart,
  onTouchEnd,
}: PTTButtonProps) {
  const baseClasses = 'select-none rounded-full flex flex-col items-center justify-center transition-all duration-150';
  const sizeClasses = 'w-48 h-48 text-xl font-bold';

  let colorClasses: string;
  let animationClass: string = '';
  let icon: string;
  let label: string;

  if (disabled) {
    colorClasses = 'bg-gray-700 text-gray-500 cursor-not-allowed';
    icon = '🔒';
    label = 'مشغول';
  } else if (isTransmitting) {
    colorClasses = 'bg-red-600 text-white cursor-pointer';
    animationClass = 'talking-pulse';
    icon = '🔴';
    label = 'يتحدث...';
  } else {
    colorClasses = 'bg-emerald-600 hover:bg-emerald-500 text-white cursor-pointer shadow-lg shadow-emerald-600/30';
    icon = '🎤';
    label = 'اضغط Space';
  }

  return (
    <button
      className={`${baseClasses} ${sizeClasses} ${colorClasses} ${animationClass}`}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      disabled={disabled}
      aria-label="Push to Talk"
    >
      <span className="text-5xl mb-2">{icon}</span>
      <span className="text-lg">{label}</span>
      {!disabled && !isTransmitting && (
        <span className="text-xs text-emerald-200 mt-1">للتحدث</span>
      )}
    </button>
  );
}
